import { atom } from 'jotai';

export const fundWalletPopupState = atom<{ currencyCode?: string; walletId?: string }>({});
